import { render, staticRenderFns } from "./inviteSuc.vue?vue&type=template&id=b8daba74&scoped=true"
import script from "./inviteSuc.vue?vue&type=script&lang=js"
export * from "./inviteSuc.vue?vue&type=script&lang=js"
import style0 from "./inviteSuc.vue?vue&type=style&index=0&id=b8daba74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8daba74",
  null
  
)

export default component.exports